module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Almost there!',
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('main', {
    staticClass: "center items-center p-5"
  }, [_c('div', {
    staticClass: "text-md"
  }, [_c('p', {
    staticClass: "px-2"
  }, [_vm._v("\n        An IT administrator at your school or district needs to approve the\n        connection to "), _c('b', [_vm._v(_vm._s(_vm.integration_name))]), _vm._v(" before we can connect.\n      ")])]), _vm._v(" "), (_vm.getProfile.role === 'teacher') ? _c('div', {
    staticClass: "px-2 mt-4"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("Admin Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none my-2 py-2 w-full rounded rounded-l-none placeholder-gray-300",
    attrs: {
      "placeholder": 'Enter admin email'
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "my-5 center items-center"
  }, [_c('button', {
    staticClass: "px-10 py-2 w-40 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("\n      Send\n    ")])]), _vm._v(" "), (_vm.error_msg) ? _c('div', {
    staticClass: "error_msg"
  }, [_vm._v("Invalid Email")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1b833cbc!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/integrationsUpgradeModal.vue
// module id = 1011
// module chunks = 61